import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useEffect, useRef, useState } from "react";
import { getTransFunc } from "../../../../../Basic/SFxLocalization";
import { notifyErrorToast } from "../../../../utils/errorToast";
import { getUserRequest, refreshUserRequest } from "../../../../api/accountSetting.api";
export function useGetUserRequest(isModalOpen) {
  var trans = getTransFunc();

  var _useState = useState({
    requestIds: [],
    requestEntities: {}
  }),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      requestIds = _useState2$.requestIds,
      requestEntities = _useState2$.requestEntities,
      setRequests = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      refreshTrigger = _useState6[0],
      setRefresh = _useState6[1];

  var refresh = function refresh() {
    return setRefresh(function (prev) {
      return prev + 1;
    });
  };

  var prevIsModalOpen = useRef();
  var prevRefreshTrigger = useRef();
  useEffect(function () {
    // Only refetch the user request list when fetchTrigger and isModalOpen changed.
    if (prevIsModalOpen.current === isModalOpen && prevRefreshTrigger.current === refreshTrigger) {
      return;
    }

    var isModalJustOpen = prevIsModalOpen.current !== isModalOpen && isModalOpen === true;
    getRequest();

    function getRequest() {
      return _getRequest.apply(this, arguments);
    }

    function _getRequest() {
      _getRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var request, _yield$request, data, requests, _error$response;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setLoading(true);
                _context.prev = 1;
                request = isModalOpen === true && !isModalJustOpen ? function () {
                  return refreshUserRequest(requestIds);
                } : function () {
                  return getUserRequest();
                };
                _context.next = 5;
                return request();

              case 5:
                _yield$request = _context.sent;
                data = _yield$request.data;

                if (Array.isArray(data)) {
                  _context.next = 9;
                  break;
                }

                throw new Error('Wrong data of user request list');

              case 9:
                requests = data.reduce(function (acc, item) {
                  return {
                    requestIds: [].concat(_toConsumableArray(acc.requestIds), [item.id]),
                    requestEntities: _objectSpread(_objectSpread({}, acc.requestEntities), {}, _defineProperty({}, item.id, item))
                  };
                }, {
                  requestIds: [],
                  requestEntities: {}
                });
                setRequests(requests);
                _context.next = 19;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](1);

                if (!(((_error$response = _context.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 404)) {
                  _context.next = 18;
                  break;
                }

                setRequests({
                  requestIds: [],
                  requestEntities: {}
                });
                return _context.abrupt("return");

              case 18:
                notifyErrorToast(trans('SFxAccountSettingsUserRequestFetchError'), _context.t0);

              case 19:
                _context.prev = 19;
                setLoading(false);
                return _context.finish(19);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 13, 19, 22]]);
      }));
      return _getRequest.apply(this, arguments);
    }

    return function () {
      prevIsModalOpen.current = isModalOpen;
      prevRefreshTrigger.current = refreshTrigger;
    };
  }, [refreshTrigger, isModalOpen, requestIds, trans]);
  return {
    isLoading: isLoading,
    requestIds: requestIds,
    requests: requestEntities,
    refresh: refresh
  };
}